export default "<p>authorizations-settings works!</p>\n"